<template>
    <pg-page title="Private Gym Rondleiding"
             header="Rondleiding"
             id="rondleiding"
    >
        Even geduld, we openen de kalender...
    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
export default {
    components: {ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        setTimeout(() => {
            Calendly.initPopupWidget({url: 'https://calendly.com/private-gym/rondleiding'});
        }, 1000)
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>

</style>
